import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ordersService from './ordersService';


export const orders = createAsyncThunk('customer/orders', async (params, {rejectWithValue}) => {
    try {
        const response = await ordersService.orders(params);
        return response;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});

export const orderDetail = createAsyncThunk('customer/orders/detail', async (params, {rejectWithValue}) => {
    try {
        const response = await ordersService.ordersDetail(params);
        
        return response.data[0];

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});

export const orderCreate = createAsyncThunk('customer/orders/create', async (data, {rejectWithValue}) => {
    try {
        const response = await ordersService.createOrder(data);
        return response;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});
export const receiptRequired = createAsyncThunk('customer/orders/receiptRequired', async (_, {rejectWithValue}) => {
    try {
        const response = await ordersService.receiptRequired(_);
        return response.receipt_required;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});

const initialState = {
    orders: {},
    orderDetail:{},
    isError: false,
    isLoading: false,
    isSuccess: false,
    isDetailSuccess: false,
    isDetailLoading: false,
    isDetailError: false,
    isCreateSuccess: false,
    isCreateLoading: false,
    isCreateError: false,
    message: '',
    receiptRequired: false,  
};

export const ordersSlice = createSlice({
    name: 'customerOrders',
    initialState,
    reducers: {
        reset: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isLoading = false;
            state.isDetailSuccess = false;
            state.isDetailLoading = false;
            state.isDetailError = false;
            state.isCreateSuccess = false;
            state.isCreateLoading = false;
            state.isCreateError = false;
            state.message = '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(orders.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(orders.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.orders = action.payload;
            })
            .addCase(orders.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
        builder
            .addCase(orderDetail.pending, (state) => {
                state.isDetailLoading = true;
            })
            .addCase(orderDetail.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isDetailSuccess = true;
                state.orderDetail = action.payload;
            })
            .addCase(orderDetail.rejected, (state, action) => {
                state.isDetailLoading = false;
                state.isDetailError = true;
                state.isDetailSuccess = false;
                state.message = action.payload;
            });
        builder
            .addCase(orderCreate.pending, (state) => {
                state.isCreateLoading = true;
            })
            .addCase(orderCreate.fulfilled, (state, action) => {
                state.isCreateLoading = false;
                state.isCreateSuccess = true;
                //state.orderDetail = action.payload;
            })
            .addCase(orderCreate.rejected, (state, action) => {
                state.isCreateLoading = false;
                state.isCreateError = true;
                state.isCreateSuccess = false;
                state.message = action.payload;
            });
        builder
            .addCase(receiptRequired.fulfilled, (state,action) => {
                state.receiptRequired = action.payload;
            })
    }
})

export const {reset} = ordersSlice.actions;
export default ordersSlice.reducer;